import React from "react";
import { Rect } from "react-konva";

import { IStatsCardProps, FOUL_CARD_TYPE } from "./types";
import * as Config from "./configuration";
import { validCoordinate } from "./utils";

const WIDTH = 4;
const HEIGHT = 6;

const getColor = (type: FOUL_CARD_TYPE) => {
  return type === "yellow" ? Config.YELLOW_CARD : Config.RED_CARD;
};

export const StatsCard = ({ from, type }: IStatsCardProps) => {
  if (!validCoordinate(from)) {
    return null;
  }
  return (
    <Rect
      x={from.x}
      y={from.y}
      width={WIDTH}
      height={HEIGHT}
      fill={getColor(type)}
    />
  );
};
